[
  {
    "key": "bar:global.ai-buddy-launch",
    "type": "bar",
    "message": "We just released Buddy, the first **AI Buddy** for your frontline workforce!",
    "cta": {
      "label": "Go to Buddy",
      "href": "/admin/chatbot"
    },
    "variant": "announcement",
    "enabled": true,
    "startAt": "2026-01-01T00:00:00.000Z",
    "endAt": "2026-12-31T23:59:59.000Z",
    "dismissible": true,
    "priority": 10,
    "routes": ["/admin"],
    "excludedRoutes": ["/admin/chatbot"]
  },
  {
    "key": "badge:main.sidebar.ai-buddy",
    "type": "badge",
    "label": "NEW",
    "variant": "new",
    "placement": "top-right",
    "offset": { "x": 15, "y": 0 },
    "animation": "shimmer",
    "labelEffect": "gradient-primary",
    "enabled": false,
    "startAt": "2026-01-01T00:00:00.000Z",
    "endAt": "2026-12-31T23:59:59.000Z",
    "routes": ["/admin"]
  },
  {
    "key": "badge:main.sidebar.tasks",
    "type": "badge",
    "label": "NEW",
    "variant": "new",
    "placement": "top-right",
    "offset": { "x": 15, "y": 0 },
    "animation": "shimmer",
    "labelEffect": "gradient-primary",
    "enabled": true,
    "startAt": "2026-01-01T00:00:00.000Z",
    "endAt": "2026-12-31T23:59:59.000Z"
  },
  {
    "key": "badge:chatbot.sidebar.settings",
    "type": "badge",
    "label": "NEW",
    "variant": "new",
    "placement": "right",
    "animation": "pulse",
    "labelEffect": "gradient-primary",
    "enabled": false,
    "startAt": "2026-01-01T00:00:00.000Z",
    "endAt": "2026-12-31T23:59:59.000Z",
    "routes": ["/admin/chatbot"]
  },
  {
    "key": "badge:chatbot.settings.enabled",
    "type": "badge",
    "label": "NEW",
    "variant": "new",
    "placement": "top-right",
    "offset": { "x": -5, "y": -10 },
    "enabled": false,
    "startAt": "2026-01-01T00:00:00.000Z",
    "endAt": "2026-12-31T23:59:59.000Z",
    "routes": ["/admin/chatbot/settings"]
  },
  {
    "key": "badge:chatbot.settings.branding",
    "type": "badge",
    "label": "NEW",
    "variant": "new",
    "placement": "right",
    "chipClassName": "tw-shadow-sm",
    "enabled": false,
    "startAt": "2026-01-01T00:00:00.000Z",
    "endAt": "2026-12-31T23:59:59.000Z",
    "routes": ["/admin/chatbot/settings"]
  },
  {
    "key": "badge:chatbot.settings.personality",
    "type": "badge",
    "label": "NEW",
    "variant": "new",
    "placement": "right",
    "enabled": false,
    "startAt": "2026-01-01T00:00:00.000Z",
    "endAt": "2026-12-31T23:59:59.000Z",
    "routes": ["/admin/chatbot/settings"]
  },
  {
    "key": "badge:chatbot.settings.audience",
    "type": "badge",
    "label": "NEW",
    "variant": "new",
    "placement": "right",
    "enabled": false,
    "startAt": "2026-01-01T00:00:00.000Z",
    "endAt": "2026-12-31T23:59:59.000Z",
    "routes": ["/admin/chatbot/settings"]
  },
  {
    "key": "badge:learning.course.tab.feedback",
    "type": "badge",
    "label": "NEW",
    "variant": "new",
    "placement": "top-right",
    "offset": { "x": 2, "y": 2 },
    "animation": "bounce",
    "labelEffect": "gradient-primary",
    "size": "xs",
    "enabled": false,
    "startAt": "2026-01-01T00:00:00.000Z",
    "endAt": "2026-12-31T23:59:59.000Z",
    "routes": ["/admin/learning/courses"]
  },
  {
    "key": "badge:learning.course.feedback.summarize-ai",
    "type": "badge",
    "label": "NEW",
    "variant": "ai",
    "placement": "top-right",
    "enabled": false,
    "animation": "pulse",
    "labelEffect": "gradient-ai",
    "startAt": "2026-01-01T00:00:00.000Z",
    "endAt": "2026-12-31T23:59:59.000Z",
    "routes": ["/admin/learning/courses"]
  },
  {
    "key": "badge:settings.sidebar.user-properties",
    "type": "badge",
    "label": "LIVE",
    "variant": "live",
    "placement": "right",
    "size": "xs",
    "enabled": false,
    "startAt": "2026-01-01T00:00:00.000Z",
    "endAt": "2026-12-31T23:59:59.000Z",
    "routes": ["/admin/settings"]
  },
  {
    "key": "badge:organisation.content.content-inspiration",
    "type": "badge",
    "label": "NEW",
    "variant": "new",
    "placement": "top-right",
    "labelEffect": "gradient-primary",
    "offset": { "x": -15, "y": -10 },
    "size": "xs",
    "enabled": true,
    "startAt": "2026-01-01T00:00:00.000Z",
    "endAt": "2026-12-31T23:59:59.000Z",
    "routes": ["/admin/content/messages"]
  },
  {
    "key": "badge:forms.detail.tab.analytics",
    "type": "badge",
    "label": "NEW",
    "variant": "new",
    "placement": "top-right",
    "offset": { "x": 10, "y": 2 },
    "color": "primary",
    "size": "xs",
    "enabled": true,
    "startAt": "2026-01-01T00:00:00.000Z",
    "endAt": "2026-12-31T23:59:59.000Z",
    "routes": ["/admin/forms", "/forms"]
  },
  {
    "key": "badge:chat.composer.voice-recorder",
    "type": "badge",
    "label": "NEW",
    "variant": "new",
    "placement": "top-right",
    "offset": { "x": 2, "y": -2 },
    "animation": "pulse",
    "size": "xs",
    "enabled": true,
    "startAt": "2026-01-01T00:00:00.000Z",
    "endAt": "2026-12-31T23:59:59.000Z",
    "routes": ["/admin", "/"]
  },
  {
    "key": "badge:performance.sidebar.cycles",
    "type": "badge",
    "label": "NEW",
    "variant": "new",
    "placement": "right",
    "animation": "shimmer",
    "size": "xs",
    "enabled": true,
    "startAt": "2026-01-01T00:00:00.000Z",
    "endAt": "2026-12-31T23:59:59.000Z",
    "routes": ["/admin/performance"]
  },
  {
    "key": "badge:survey.pulse.tab.submissions",
    "type": "badge",
    "label": "NEW",
    "variant": "new",
    "placement": "top-right",
    "offset": { "x": 10, "y": 2 },
    "size": "xs",
    "enabled": true,
    "startAt": "2026-01-01T00:00:00.000Z",
    "endAt": "2026-12-31T23:59:59.000Z",
    "routes": ["/admin/surveys"]
  },
  {
    "key": "badge:events.form.recurrence",
    "type": "badge",
    "label": "NEW",
    "variant": "new",
    "placement": "right",
    "size": "xs",
    "enabled": true,
    "startAt": "2026-01-01T00:00:00.000Z",
    "endAt": "2026-12-31T23:59:59.000Z",
    "routes": ["/admin/events", "/events"]
  },
  {
    "key": "bar:global.launch",
    "type": "bar",
    "message": "New feature!",
    "variant": "announcement",
    "routes": ["/"],
    "enabled": false,
    "startAt": "2026-01-01T00:00:00.000Z",
    "endAt": "2026-12-31T23:59:59.000Z"
  },
  {
    "key": "badge:events.form.types",
    "type": "badge",
    "label": "NEW",
    "variant": "new",
    "placement": "right",
    "size": "xs",
    "enabled": true,
    "startAt": "2026-01-01T00:00:00.000Z",
    "endAt": "2026-12-31T23:59:59.000Z",
    "routes": ["/admin/events", "/events"]
  },
  {
    "key": "badge:network.timeline.pulse-survey",
    "type": "badge",
    "label": "NEW",
    "variant": "new",
    "placement": "top-right",
    "offset": { "x": 8, "y": -4 },
    "size": "xs",
    "enabled": true,
    "startAt": "2026-01-01T00:00:00.000Z",
    "endAt": "2026-12-31T23:59:59.000Z",
    "routes": ["/networks"]
  },
  {
    "key": "badge:events.form.require-decline-reason",
    "type": "badge",
    "label": "NEW",
    "variant": "new",
    "placement": "right",
    "size": "xs",
    "enabled": true,
    "startAt": "2026-01-01T00:00:00.000Z",
    "endAt": "2026-12-31T23:59:59.000Z",
    "routes": ["/admin/events", "/events"]
  },
  {
    "key": "badge:events.decline-reason.modal",
    "type": "badge",
    "label": "NEW",
    "variant": "new",
    "placement": "right",
    "size": "xs",
    "enabled": true,
    "startAt": "2026-01-01T00:00:00.000Z",
    "endAt": "2026-12-31T23:59:59.000Z",
    "routes": ["/events", "/networks"]
  },
  {
    "key": "badge:events.guest-list.decline-reason",
    "type": "badge",
    "label": "NEW",
    "variant": "new",
    "placement": "right",
    "size": "xs",
    "enabled": true,
    "startAt": "2026-01-01T00:00:00.000Z",
    "endAt": "2026-12-31T23:59:59.000Z",
    "routes": ["/admin/events", "/events"]
  },
  {
    "key": "badge:settings.user-properties.visibility",
    "type": "badge",
    "label": "NEW",
    "variant": "new",
    "placement": "right",
    "size": "xs",
    "animation": "pulse",
    "enabled": true,
    "startAt": "2026-01-01T00:00:00.000Z",
    "endAt": "2026-12-31T23:59:59.000Z",
    "routes": ["/admin/settings/user-properties"]
  },
  {
    "key": "badge:forms.settings.respondent-anonymity-choice",
    "type": "badge",
    "label": "NEW",
    "variant": "new",
    "placement": "right",
    "size": "xs",
    "enabled": true,
    "startAt": "2026-01-01T00:00:00.000Z",
    "endAt": "2026-12-31T23:59:59.000Z",
    "routes": ["/admin/forms", "/forms"]
  },
  {
    "key": "badge:survey.publish.respondent-anonymity-choice",
    "type": "badge",
    "label": "NEW",
    "variant": "new",
    "placement": "right",
    "size": "xs",
    "enabled": true,
    "startAt": "2026-01-01T00:00:00.000Z",
    "endAt": "2026-12-31T23:59:59.000Z",
    "routes": ["/admin/surveys"]
  }
]
